export const MORE_INFO = {
  en_US: 'More information',
  es_ES: 'Más información',
  pt_BR: 'Mais informações',
};
